<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-30 09:39:24
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\realTimeInventory\components\cancelCodeList.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="70%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>查看</div>
      <div>
        <el-button @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <el-form ref="form" label-width="110px" label-suffix="：">
        <div class="box-title">产品信息</div>
        <div class="gird-container">
          <el-form-item label="物料名称">
            <div class="form-content" :title="inventoryInfo.materialName">{{ inventoryInfo.materialName }}</div>
          </el-form-item>
          <el-form-item label="物料规格型号">
            <div class="form-content" :title="inventoryInfo.materialSpecifications">{{ inventoryInfo.materialSpecifications }}</div>

          </el-form-item>
          <el-form-item label="包装级别">
            <div class="form-content" :title="inventoryInfo.packageLevel"> {{ inventoryInfo.packageLevel }}</div>
          </el-form-item>
          <el-form-item label="批号" :title="inventoryInfo.batchNo">
            <div class="form-content"> {{ inventoryInfo.batchNo }}</div>
          </el-form-item>
          <el-form-item label="失效日期" :title="inventoryInfo.loseTime">
            <div class="form-content">
              {{ inventoryInfo.loseTime ? parseTime(inventoryInfo.loseTime, '{y}-{m}-{d}') : null }}

            </div>
          </el-form-item>
          <el-form-item label="生产日期" :title="inventoryInfo.productTime">
            <div class="form-content">
              {{ inventoryInfo.productTime ? parseTime(inventoryInfo.productTime, '{y}-{m}-{d}') : null }}
            </div>
          </el-form-item>
          <el-form-item label="码类型">
            <div class="form-content">
              {{ isSingle ? '唯一码' : '批次码' }}
            </div>
          </el-form-item>
        </div>

        <template>
          <div class="box-title">报废的UDI码</div>
          <br/>
          <el-table ref="dataTable" align="center" v-loadlog="loading"  :data="dataList" border >
            <el-table-column show-overflow-tooltip min-width="200" prop="code" label="UDI码" />
            <el-table-column v-if="!isSingle" prop="quantity" label="数量" width="130">
              <template slot-scope="{row }">
                {{ inventoryInfo.quantity }}
              </template>
            </el-table-column>
          </el-table>
          <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
            :limit.sync="searchParam.pageSize" @pagination="getList" />
        </template>

      </el-form>
    </el-card>
  </el-drawer>
</template>

<script>
import { getCancelCodePage } from '@/api/cancel'
export default {
  name: 'DetialInventory',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    inventoryInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    dictObj: {
      type: Object,
      default() {
        return {
          receiptDeliveryState: []
        }
      }
    }
  },
  data() {
    // 这里存放数据
    return {
      invalidShow: false,
      selectList: [],// 选中列表

      loading: false,
      dataList: [],
      searchParam: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        code:''
      }
    }
  },
  computed: {
    isSingle() {
      if(this.dataList.length>0){
        return this.dataList[0] ?    this.dataList[0].code.indexOf('(21)') !== -1: false
      }else {
        return true
      }
    }
  },
  created() {
    this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
    console.log(this.inventoryInfo)
    if (this.inventoryInfo.id) {
      this.getList(this.inventoryInfo)
    }
  },
  // 方法集合
  methods: {
    close() {
      this.invalidShow=false
      if(!this.isSingle){
        this.$emit('close')
      }
    },

    // 获取出入库记录
    getList() {
      this.loading=true
      getCancelCodePage({ cancelId: this.inventoryInfo.id, ...this.searchParam }).then((res) => {
        this.dataList = res.rows
        this.searchParam.total = res.total
        this.loading=false
      }).catch(ex=>{
        this.loading=false
      })
    },
  }
}
</script>

<style scoped>
.gird-container {
  display: grid;
  grid-template-columns: repeat(4, 25%);
}

.form-content {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
